module.exports = __webpack_public_path__ + "img/circle-v.5ed36c43.svg";